
window.onload = () => {

(function () {

  function waitForSizeOption(callback) {
    const check = setInterval(() => {
      const sizeLis = document.querySelectorAll('div[option-name="Size"] ul li');

      if (sizeLis.length > 0) {
        clearInterval(check);
        callback();
      }
    }, 100);

    setTimeout(() => clearInterval(check), 10000);
  }

  function initSizeValidation() {
    if (window.__sizeValidationInitialized) return;
    window.__sizeValidationInitialized = true;

    const getSizeLis = () => document.querySelectorAll('div[option-name="Size"] ul li');
    const getAddToCartBtns = () => document.querySelectorAll('.product-form__submit');

    let userSelectedSize = false; // ✅ TRACK USER ACTION

    // --- ERROR MESSAGE ---
    const errorMsg = document.createElement('div');
    errorMsg.classList.add('size-error-close');
    errorMsg.innerHTML = '<span>&times;</span>&#x1F52E; Please select a size';

    Object.assign(errorMsg.style, {
      color: '#000',
      fontSize: '14px',
      marginBottom: '10px',
      display: 'none'
    });

    function insertErrorMsg() {
      const btns = getAddToCartBtns();
      if (btns.length && !btns[0].previousSibling?.classList?.contains('size-error-close')) {
        btns[0].parentNode.insertBefore(errorMsg, btns[0]);
      }
    }

    const isSizeSelected = () =>
      Array.from(getSizeLis()).some(li => li.getAttribute('aria-checked') === 'true');

    const disableATC = () => getAddToCartBtns().forEach(b => b.disabled = true);
    const enableATC = () => getAddToCartBtns().forEach(b => b.disabled = false);

    function unselectAllSizes() {
      getSizeLis().forEach(li => {
        li.setAttribute('aria-checked', 'false');
        li.querySelectorAll('.swatch-selected').forEach(el =>
          el.classList.remove('swatch-selected')
        );
      });
    }

    insertErrorMsg();

    // --- REMOVE DEFAULT SELECTION ON LOAD ---
    unselectAllSizes();

    // --- SIZE CLICK ---
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('div[option-name="Size"] .swatch-button');
      if (!btn) return;

      const li = btn.closest('li');
      if (!li) return;

      unselectAllSizes();
      li.setAttribute('aria-checked', 'true');

      const selectedChild = li.querySelector('.swatch-button');
      if (selectedChild) selectedChild.classList.add('swatch-selected');

      userSelectedSize = true; // ✅ USER HAS SELECTED

      errorMsg.style.display = 'none';
      enableATC();
    });

    // --- ADD TO CART ---
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.product-form__submit');
      if (!btn) return;

      if (!isSizeSelected()) {
        e.preventDefault();
        errorMsg.style.display = 'flex';
        disableATC();
      }
    });

    // --- COLOR CLICK ---
    document.addEventListener('click', function(e) {
      const colorBtn = e.target.closest('div[option-name="Color"] .swatch-selector');
      if (!colorBtn) return;

     

        if (!userSelectedSize) {
          // ❌ If user never selected → remove auto चयन
          unselectAllSizes();
          
        } else {
          // ✅ If user selected → keep selection
          enableATC();
        }

        errorMsg.style.display = 'none';
     
    });

    // --- OBSERVER (for safety) ---
    const obs = new MutationObserver(() => {
      insertErrorMsg();
    });

    obs.observe(document.body, { childList: true, subtree: true });

  }

  waitForSizeOption(() => {
    setTimeout(initSizeValidation, 10);
  });

})();
};



document.addEventListener('DOMContentLoaded', function () {

  let previousSize = null;

  // Track size click (delegated)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('div[option-name="Size"] .swatch-selector');
    if (!btn) return;

    previousSize = btn.getAttribute('data-value') || null;
   // alert("Previous size selected: " + previousSize);
  });

  // Listen for color clicks
  document.addEventListener('click', function (e) {
    const el = e.target.closest('.swatch-selector');
    if (!el) return;

    const optionType = el.getAttribute('swatch-option');

    if (optionType === 'option1') {

     

        const sizeContainer = document.querySelector('div[option-name="Size"]');
        if (!sizeContainer) return;

        let previousSizeExists = false;

        if (previousSize) {
          previousSizeExists = !!sizeContainer.querySelector(
            `.swatch-selector[data-value="${previousSize}"]`
          );
        }

       // alert("Check after color click: " + previousSize);

        if (!previousSizeExists) {
          sizeContainer.querySelectorAll('.swatch-selector').forEach(btn => {
            const parent = btn.closest('.swatch-view-item');
            if (!parent) return;

            btn.classList.remove('swatch-selected');
            parent.setAttribute('aria-checked', 'false');
            parent.setAttribute('tabindex', '-1');
          });

          const label = sizeContainer.querySelector('.swatch-variant-name');
          if (label) label.innerHTML = '';

          previousSize = null;
        }

     
    }
  });

});